export default "__VITE_ASSET__BrOfDlZr__"